import React from "react";
import { ReactComponent as Logo } from "./images/logo.svg";

export const NomuraLogo = ({ styles, className = "mx-auto w-100" }) => (
  <Logo className={`d-block maxw-400 text-primary fill-red ${className}`} style={styles} />
);
